import { QueryClient } from '@tanstack/react-query';

import { isAPIError } from '../network/types';
import { ToastManager } from '../toast/utils';

export const DEFAULT_CACHE_TIME = 5 * 60 * 1000; // 5 minutes

export const silentQueryErrorHandler = (error: unknown) => queryErrorHandler(error, true);

export const queryErrorHandler = (error: unknown, silent?: boolean) => {
  if (isAPIError(error)) {
    const { message } = error;

    if (!silent) {
      ToastManager.show({ message, severity: 'error' });
    }
  }
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      onError: queryErrorHandler,
      refetchOnWindowFocus: false,
      retry: 0,
      cacheTime: DEFAULT_CACHE_TIME,
    },
    mutations: {
      onError: (error: unknown) => queryErrorHandler(error, false),
    },
  },
});
